















































































































































































































import Vue from 'vue';
import { Type, TypeMap, Operation, OperationTypes, ObjectType } from 'expangine-runtime';
import { OperationVisuals } from '../runtime/ops/OperationVisuals';
import { Registry } from '../runtime/Registry';
import { getTestOperation } from './TestOperation';


const COMPLEXITY_LABELS = [
  'Low',
  'Medium',
  'High',
  'Very High',
];
const COMPLEXITY_LABEL_MAX = 'Too High';
const COMPLEXITY_COLORS = [
  'green',
  'yellow',
  'orange',
  'red darken-4',
];
const COMPLEXITY_COLOR_MAX = 'black';


export default Vue.extend({
  name: 'OperationInfo',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    registry: {
      type: Object as () => Registry,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    inspecting: false,
  }),
  computed: {
    visible: {
      get(): boolean {
        return this.show;
      },
      set(value: boolean) {
        this.$emit('update:show', value);
      },
    },
    operation(): Operation<any, any, any, any, any> | null {
      return this.registry.defs.getOperation(this.name);
    },
    operationTypes(): OperationTypes<any, any, any> | null {
      return this.registry.defs.getOperationTypes(this.name);
    },
    operationVisuals(): OperationVisuals {
      return this.registry.getOperationVisuals(this.name);
    },
    operationName(): string {
      return this.operationVisuals.name;
    },
    operationDescription(): string {
      return this.operationVisuals.description;
    },
    complexity(): number {
      return this.operation
        ? this.operation.complexity
        : 0;
    },
    operationComplexity(): string {
      return COMPLEXITY_LABELS[Math.round(this.complexity)] || COMPLEXITY_LABEL_MAX;
    },
    operationComplexityColor(): string {
      return COMPLEXITY_COLORS[Math.round(this.complexity)] || COMPLEXITY_COLOR_MAX;
    },
    paramTypes(): TypeMap {
      return this.registry.defs.getOperationExpectedTypes(this.name, {}, {}, ObjectType.baseType);
    },
    returnType(): Type | null {
      return this.operationTypes 
        ? this.registry.defs.getOperationInputType(this.operationTypes.returnType, this.paramTypes)
        : null;
    },
  },
  methods: {
    describeType(type?: Type): string {
      return type ? this.registry.getTypeDescribeLong(type, '&nbsp;&nbsp;', '<br>') : '';
    },
    scopeType(name: string): Type | null {
      return this.operationTypes
        ? this.registry.defs.getOperationInputType(this.operationTypes.scope[name], this.paramTypes)
        : null;
    },
    test() {
      const { name, registry } = this;

      getTestOperation({ name, registry });
    },
  },
});
